// app/services/user.service.js
import { api } from './api';

class UserService {
    // Get users with pagination and filters
    async getUsers(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/api/admin/users?${queryString}`);
    }

    // Get single user by ID
    async getUserById(userId) {
        return api.get(`/api/admin/users/${userId}`);
    }

    // Create new user
    async createUser(userData) {
        return api.post('/api/admin/users', userData);
    }

    // Update user
    async updateUser(userId, userData) {
        return api.put(`/api/admin/users/${userId}`, userData);
    }

    // Delete/Deactivate user
    async deleteUser(userId) {
        return api.delete(`/api/admin/users/${userId}`);
    }

    // Get available roles
    async getRoles(params = {}) {
        // Set default parameters to match the verified API call
        const defaultParams = {
            page: 1,
            limit: 20,
            include_permissions: true,
            include_stats: true,
            ...params // Allow overriding defaults
        };
        const queryString = new URLSearchParams(defaultParams).toString();
        return api.get(`/api/admin/roles/?${queryString}`);
    }

    // Get role permissions
    async getRolePermissions(roleId) {
        const response = await api.get(`/api/admin/roles/${roleId}`);
        const permissions = response.permissions || [];
        return {
            permissions: permissions.map(perm => perm.id)
        };
    }

    // Update role permissions
    async updateRolePermissions(roleId, permissions) {
        return api.put(`/api/admin/roles/${roleId}/permissions`, { 
            permission_ids: permissions 
        });
    }

    // Create new role
    async createRole(roleData) {
        return api.post('/api/admin/roles', roleData);
    }

    // Update role
    async updateRole(roleId, roleData) {
        return api.put(`/api/admin/roles/${roleId}`, roleData);
    }

    // Get all permissions
    async getPermissions() {
        const response = await api.get('/api/admin/roles/permissions/all?grouped=false');
        return {
            items: response.permissions || []
        };
    }

    // Update user password
    async updateUserPassword(userId, password) {
        return api.put(`/api/admin/users/${userId}/password`, { password });
    }
}

export const userService = new UserService();